import React from "react";
import { useColors } from "../constants/Colors";

interface Filter {
  id: string;
  label: string;
  isSelected: boolean;
  onPress: () => void;
}

interface FilterTagsProps {
  filters: Filter[];
  onPressAll?: () => void;
  isAllSelected?: boolean;
  horizontalPadding?: boolean;
}

const FilterTags: React.FC<FilterTagsProps> = ({
  filters,
  onPressAll,
  isAllSelected,
  horizontalPadding,
}) => {
  const colors = useColors();

  // Filter out "accepted" from visual display (but keep functionality)
  const visibleFilters = filters.filter((f) => f.id !== "accepted");

  // All is selected if no other filter is selected
  const anySelected = visibleFilters.some((f) => f.isSelected);
  const allIsSelected = isAllSelected ?? !anySelected;

  return (
    <div className="w-0 min-w-full">
      <div className={`flex gap-2 overflow-x-auto pb-2 scrollbar-hide ${horizontalPadding ? "pl-4 pr-4" : ""}`}>
        {/* All button */}
        <button
          onClick={onPressAll}
          className="px-4 py-1.5 rounded-full whitespace-nowrap transition-colors flex-shrink-0"
          style={{
            backgroundColor: allIsSelected
              ? colors.accentColor + "20"
              : colors.containerNeutralLightLowest,
            color: allIsSelected ? colors.accentColor : colors.textNeutralMuted,
          }}
        >
          All
        </button>

        {/* Other filters */}
        {visibleFilters.map((filter) => (
          <button
            key={filter.id}
            onClick={filter.onPress}
            className="px-4 py-1.5 rounded-full whitespace-nowrap transition-colors flex-shrink-0"
            style={{
              backgroundColor: filter.isSelected
                ? colors.accentColor + "20"
                : colors.containerNeutralLightLowest,
              color: filter.isSelected
                ? colors.accentColor
                : colors.textNeutralMuted,
            }}
          >
            {filter.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default FilterTags;
